export const CE_ESTADOS_ALARMA = [
    "Desarmada", "Armada", "ALARMADA", "Dly Salida", "Dly Entrada",
    "BLOQUEADA", "ALARMADA PANICO", "ALARMADA FUEGO", "ALARMADA GAS", "Desarmar",
    "---", "---", "---", "---", "---",
    "---", "---", "---", "Estado Desconocido",
];

// 1. Mapa de tus estados (Clave: Valor numérico, Valor: Texto) para gráfico en reportes
export const estadosAlarma = {
    0: "Desarmada (OFF)",
    1: "Armada (ON)",
    2: "¡ALARMADA!",
    3: "Dly Salida",
    4: "Dly Entrada",
    5: "BLOQUEADA",
    6: "ALARMADA PANICO",
    7: "ALARMADA FUEGO",
    8: "ALARMADA GAS",
    9: "Desarmar",
    10: "Transitorio",
};

export const accionesAlarma = {
    0:          "Ninguno",
    1:          "Alarma Armada",
    2:          "-- Alarma Alarmada --",
    3:          "Delay Salida",
    4:          "Delay Entrada",
    5:          "Alarma Bloqueada",
    6:          "-- Alarmada Pánico --",
    7:          "-- Alarmada Fuego --",
    8:          "-- Alarmada Gas --",
    9:          "Alarma Desarmada",
    102:        "Armar Alarma",
    103:        "Armar Err Clave",
    104:        "Desarmar Alarma",
    105:        "Desarmar Err Clave",
    106:        "Configurar",
    108:        "Consulta Estado",
    109:        "Reporte Estado",
    //Eventos otros sensores
    120:        "Voltaje AC",     // Alarma porque las entradas de 220v no estan correctas, con datos relevantes
    122:        "Flotadores",     // Alarma porque el agua esta revalsando del tanque, con datos relevantes 
    // Mensajes de eventos relacionados con las puertas
    140:        "Abrir Puerta",
    141:        "Puerta Abierta",
    142:        "Inicializar Puertas",
    143:        "Evento Puertas",
    144:        "Chapa Abierta",
    146:        "Estado Puertas",
    148:        "Evento Puertas",
    // Mesajes de eventos generales
    180:        "Envio de Dev Info",
};

export const mediosAlarma = {
    0:      "---",
    1:      "WiFi",
    2:      "GPRS",
    3:      "Bluetooth",
    4:      "Telegram",
    5:      "Aplicación",
    6:      "WEB",
};

export const CE_ESTADOS_ZONA = [
    "No Habilitada", "",  "", "", "", "", "", "", "", "", 
    "", "", "", "", "", "", "Normal", "Violada", "Movimiento", "Armada",  
    "Bypass",  "Delay Salida",  "Delay Entrada", "", "", "", "", "", "", "",
    "", "", "Normal",  "Pánico Violada",  "Normal",  "Fuego Violada",  "Normal", "Gas Violada",
];

export const CE_HABILITACIONES_ZONA = [
    "No Habilitada", "",  "", "", "", "", "", "", "", "", 
    "", "", "", "", "", "", "Habilitada", "", "", "",  
    "",  "",  "", "", "", "", "", "", "", "",
    "", "", "Pánico",  "",  "Fuego",  "",  "Gas", "",
];